import React from "react";
import { useAuth } from "../hooks/useAuth";

interface PermissionGuardProps {
  permission: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

const PermissionGuard = ({
  permission,
  children,
  fallback = null,
}: PermissionGuardProps) => {
  const { admin } = useAuth();

  if (!admin) return null;

  if (admin.role === "super_admin") {
    return <>{children}</>;
  }

  const hasPermission = admin.permissions?.includes(permission);

  if (hasPermission) {
    return <>{children}</>;
  }

  return <>{fallback}</>;
};

export default PermissionGuard;
